/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PropertyValue } from '@/types'
import { type Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { Listbox, Transition } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import ImageOptimize from '../ImageOptimize'
import { Loading } from '../Loading/Loading'

interface FilterDataProps {
  name: string
  values: PropertyValue[] | string[]
  value: any
  data: PropertyValue[]
}
export interface FilterItem {
  className?: string
  filterGroup: Property
  title?: string
  filterKey?: string
  index: number
  selectedFilterByKey: (params: any) => void
  onChange: () => void
  filterData: FilterDataProps[]
  setFilterData: Dispatch<SetStateAction<FilterDataProps[]>>
  fetchFilter: boolean
  setFetchFilter: Dispatch<SetStateAction<boolean>>
}
export const FilterItem = ({
  title,
  className,
  filterGroup,
  selectedFilterByKey = () => true,
  onChange = () => true,
  filterKey,
  filterData,
  fetchFilter,
  index,
  setFetchFilter,
}: FilterItem) => {
  const [isLoading, setIsLoading] = useState(false)
  const [selected, setSelected] = useState<string[]>([])
  const onChangeFilter = async (e: string[]) => {
    setSelected(e)
    selectedFilterByKey([{ name: filterKey, values: e, value: e.toString() }])
    setIsLoading(true)
    setFetchFilter(true)
    setTimeout(() => {
      setIsLoading(false)
    }, 300)
  }
  function clearFilter() {
    setSelected([])
    selectedFilterByKey([{ name: filterKey, values: [], value: null }])
    onChange()
    setFetchFilter(true)
  }
  function onSubmitFilter() {
    selectedFilterByKey([{ name: filterKey, values: selected, value: null }])
    onChange()
  }
  useEffect(() => {
    filterData.map((e: any) => {
      if (e.name === getPath(filterGroup.slugs) && e.values.length > 0) {
        setSelected([...e.values])
      }
      if (e.name === getPath(filterGroup.slugs) && e.values.length == 0) {
        setSelected([])
      }
    })
  }, [filterData, fetchFilter, filterGroup])

  return (
    <div className={`${className ? className : ''} `}>
      <Listbox
        value={selected}
        onChange={onChangeFilter}
        multiple
        as='div'
        horizontal={true}
      >
        {({ open }) => (
          <div className={`relative ${open ? 'z-[30]' : 'z-10'}`}>
            <Listbox.Button
              className={`relative h-10 w-full rounded-lg border border-dark-200 bg-white pl-2 pr-[30px]  text-sm focus:outline-none focus-visible:border-primary-base ${
                open ? 'z-[9999]' : 'z-10'
              }`}
            >
              <span className='block truncate'>{title}</span>
              <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                <span className='icon' aria-hidden='true'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={10}
                    height={8}
                    viewBox='0 0 10 8'
                    fill='none'
                  >
                    <path
                      d='M4.68994 7.11426L9.23657 0.956238H0.143308L4.68994 7.11426Z'
                      fill='#6F6F6F'
                    />
                  </svg>
                </span>
              </span>
            </Listbox.Button>
            <Transition>
              <Transition.Child>
                <div className='fixed inset-0 left-0 top-0 bg-dark-900/40' />
              </Transition.Child>
              <Listbox.Options
                as='div'
                static
                className={`absolute mt-1 flex w-[600px] cursor-pointer flex-wrap items-start justify-start overflow-auto rounded-md bg-white text-base ${
                  index < 3 ? 'left-0' : 'right-0'
                }`}
              >
                <div className='flex w-full flex-wrap gap-2 px-3 pb-2 pt-3'>
                  {filterGroup.values.map((attribute, attributeIdx) => (
                    <Listbox.Option
                      as='div'
                      key={attributeIdx}
                      className={({ selected }) =>
                        `relative flex h-9 items-center rounded border bg-white  text-sm ${
                          selected ? 'border-primary-base' : 'border-dark-200'
                        } hover:border-primary-base hover:text-primary-base`
                      }
                      value={getTranslate(attribute.value)}
                    >
                      {filterGroup?.slugs?.postfix === '-brand' ? (
                        <ImageOptimize
                          src={attribute?.image}
                          alt={getTranslate(attribute.value)}
                          width={120}
                          height={20}
                          className='h-5 w-auto px-1'
                        />
                      ) : (
                        <span className={`block truncate px-2`}>
                          {getTranslate(attribute.value)}
                        </span>
                      )}
                    </Listbox.Option>
                  ))}
                </div>
                {selected && selected.length > 0 ? (
                  <div className='actionFilter mt-1 flex w-full justify-center gap-3 pb-2 pt-1 shadow'>
                    <Listbox.Button
                      onClick={clearFilter}
                      className=' flex h-9 items-center rounded border border-primary-second px-3 text-center  text-sm font-bold uppercase text-primary-second'
                    >
                      BỎ CHỌN
                    </Listbox.Button>
                    <Listbox.Button
                      onClick={() => onSubmitFilter()}
                      className='flex h-9 items-center rounded bg-red-600 px-3 text-center  text-sm font-bold uppercase text-white'
                    >
                      {isLoading ? <Loading /> : ''}
                      XÁC NHẬN
                    </Listbox.Button>
                  </div>
                ) : (
                  ''
                )}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </div>
  )
}
